function initializeTheme() {
  initSliders();
  initPredictiveSearch();
  initLocalizationSelector();
  initCartDrawer();
  initMobileMenu();
  initMobileSearch();
  initMobilePredictiveSearch();
  initBottomNavActiveState();
  initPasswordModal();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeTheme);
} else {
  initializeTheme();
}

/**
 * Initialize SplideJS Sliders
 */
function initSliders() {

  // 1. Announcement Bar Slider
  const annSlider = document.getElementById('AnnouncementSlider');
  if (annSlider && typeof Splide !== 'undefined') {
    new Splide(annSlider, {
      type: 'fade',
      autoplay: true,
      interval: 5000,
      rewind: true,
      arrows: false,
      pagination: false,
      speed: 800
    }).mount();
  }

  // 2. Hero Slider
  const heroSlider = document.getElementById('HeroSlider');
  if (heroSlider && typeof Splide !== 'undefined') {
    new Splide(heroSlider, {
      type: 'fade',
      rewind: true,
      autoplay: true,
      interval: 6000,
      speed: 800,
      classes: {
        pagination: 'splide__pagination hero__dots',
        page: 'splide__pagination__page dot',
        arrow: 'splide__arrow hero__arrow',
        prev: 'splide__arrow--prev',
        next: 'splide__arrow--next'
      }
    }).mount();
  }

  // 3. Product Slider
  const productSliders = document.querySelectorAll('[id^="ProductSlider-"]');
  productSliders.forEach(slider => {
    if (slider && typeof Splide !== 'undefined') {
      new Splide(slider, {
        type: 'slide',
        perPage: 4,
        gap: 20,
        pagination: false,
        breakpoints: {
          1024: {
            perPage: 2
          },
          768: {
            perPage: 1
          }
        },
        classes: {
          arrows: 'best__nav splide__arrows',
          arrow: 'carousel-btn splide__arrow',
          prev: 'splide__arrow--prev',
          next: 'splide__arrow--next'
        }
      }).mount();
    }
  });

  // 4. Personalisation Slider
  const persSliders = document.querySelectorAll('[id^="PersSlider-"]');
  persSliders.forEach(slider => {
    if (slider && typeof Splide !== 'undefined') {
      new Splide(slider, {
        type: 'fade',
        rewind: true,
        autoplay: true,
        interval: 5000,
        speed: 800,
        arrows: false,
        classes: {
          pagination: 'splide__pagination pers__img-dots',
          page: 'splide__pagination__page pers__dot'
        }
      }).mount();
    }
  });

  // 5. Trust Bar Slider
  const trustSlider = document.getElementById('TrustSlider');
  if (trustSlider && typeof Splide !== 'undefined') {
    new Splide(trustSlider, {
      type: 'loop',
      autoplay: true,
      interval: 3000,
      speed: 800,
      arrows: false,
      pagination: false,
      perPage: 4,
      gap: 16,
      drag: true,
      breakpoints: {
        1024: {
          perPage: 2,
          gap: 16
        },
        768: {
          perPage: 1,
          gap: 16,
          focus: 'center',
          padding: '15%'
        }
      }
    }).mount();
  }
}

/**
 * Predictive Search (AJAX)
 */
function initPredictiveSearch() {
  const searchInput = document.getElementById('HeaderSearchInput');
  const resultsContainer = document.getElementById('PredictiveSearchResults');
  const resultsList = document.getElementById('PredictiveSearchResultsList');
  const loadingIndicator = resultsContainer ? resultsContainer.querySelector('.predictive-search__loading') : null;

  if (!searchInput || !resultsContainer || !resultsList) return;

  let debounceTimer;

  searchInput.addEventListener('input', () => {
    clearTimeout(debounceTimer);
    const query = searchInput.value.trim();

    if (query.length < 2) {
      resultsContainer.classList.remove('active');
      resultsList.innerHTML = '';
      return;
    }

    resultsContainer.classList.add('active');
    if (loadingIndicator) loadingIndicator.style.display = 'block';
    resultsList.innerHTML = '';

    debounceTimer = setTimeout(() => {
      fetch(`${window.routes.search_url}/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5`)
        .then(response => response.json())
        .then(data => {
          if (loadingIndicator) loadingIndicator.style.display = 'none';
          
          const products = data.resources.results.products;
          if (products && products.length > 0) {
            let html = '';
            products.forEach(product => {
              // Convert price to money format (e.g. £12.99 or similar depending on currency)
              const priceFormatted = product.price ? product.price : '';
              html += `
                <a href="${product.url}" class="predictive-search__item">
                  ${product.image ? `<img src="${product.image}" alt="${product.title}" class="predictive-search__item-img">` : ''}
                  <div class="predictive-search__item-info">
                    <h4 class="predictive-search__item-title">${product.title}</h4>
                    <span class="predictive-search__item-price">${priceFormatted}</span>
                  </div>
                </a>
              `;
            });
            resultsList.innerHTML = html;
          } else {
            resultsList.innerHTML = `<p style="padding: 15px; font-size: 14px; color: var(--mid); text-align: center;">No results found for "${query}"</p>`;
          }
        })
        .catch(err => {
          console.error(err);
          if (loadingIndicator) loadingIndicator.style.display = 'none';
          resultsList.innerHTML = '<p style="padding: 15px; font-size: 14px; color: var(--pink); text-align: center;">Error loading search results</p>';
        });
    }, 300);
  });

  // Close search results when clicking outside
  document.addEventListener('click', (e) => {
    if (!searchInput.contains(e.target) && !resultsContainer.contains(e.target)) {
      resultsContainer.classList.remove('active');
    }
  });
}

/**
 * Currency/Localization Picker Dropdown
 */
function initLocalizationSelector() {
  const btn = document.getElementById('CurrencySelectorBtn');
  const list = document.getElementById('HeaderCurrencyList');
  const form = document.getElementById('HeaderCurrencyForm');
  const input = document.getElementById('CountryCodeField');

  if (!btn || !list || !form || !input) return;

  btn.addEventListener('click', (e) => {
    e.stopPropagation();
    const isExpanded = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', !isExpanded);
  });

  document.addEventListener('click', (e) => {
    if (!list.contains(e.target) && !btn.contains(e.target)) {
      btn.setAttribute('aria-expanded', 'false');
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      btn.setAttribute('aria-expanded', 'false');
    }
  });

  list.querySelectorAll('.currency-option').forEach(option => {
    option.addEventListener('click', (e) => {
      e.preventDefault();
      input.value = option.dataset.value;
      form.submit();
    });
  });
}

/**
 * AJAX Side Cart Drawer
 */
function initCartDrawer() {
  const trigger = document.getElementById('CartDrawerTrigger');
  const closeBtn = document.getElementById('CartDrawerClose');
  const overlay = document.getElementById('CartDrawerOverlay');
  const drawer = document.getElementById('CartDrawer');
  const itemsContainer = document.getElementById('CartDrawerItems');
  const emptyState = document.getElementById('CartDrawerEmpty');
  const subtotalLabel = document.getElementById('CartDrawerSubtotal');
  const badgeCount = document.getElementById('CartDrawerBadgeCount');
  
  if (!trigger || !closeBtn || !overlay || !drawer) return;

  // Toggle drawer open
  const openDrawer = () => {
    drawer.classList.add('active');
    overlay.classList.add('active');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.setAttribute('aria-hidden', 'false');
    fetchCartData();
  };

  // Toggle drawer close
  const closeDrawer = () => {
    drawer.classList.remove('active');
    overlay.classList.remove('active');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('aria-hidden', 'true');
  };

  trigger.addEventListener('click', openDrawer);
  closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);

  // Keyboard accessibility
  trigger.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      openDrawer();
    }
  });

  // Fetch cart data from Shopify Cart API
  function fetchCartData() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        updateBadgeAndFooter(cart);
        renderCartItems(cart);
      })
      .catch(err => console.error('Error fetching cart:', err));
  }

  // Render HTML cart item cards
  function renderCartItems(cart) {
    if (!itemsContainer) return;

    if (cart.item_count === 0) {
      itemsContainer.style.display = 'none';
      if (emptyState) emptyState.style.display = 'block';
      return;
    }

    itemsContainer.style.display = 'block';
    if (emptyState) emptyState.style.display = 'none';

    let html = '';
    cart.items.forEach(item => {
      // Handle variant title if not default
      const variantTitleHtml = item.variant_title ? `<p class="cart-drawer-item__variant">${item.variant_title}</p>` : '';
      const priceFormatted = formatMoney(item.line_price, Shopify.money_format || '£{{amount}}');
      
      // Handle properties if present
      let propertiesHtml = '';
      if (item.properties && Object.keys(item.properties).length > 0) {
        propertiesHtml += '<div class="cart-drawer-item__properties" style="font-size: 11px; color: var(--mid); margin-top: 4px; display: flex; flex-direction: column; gap: 2px;">';
        for (const [key, value] of Object.entries(item.properties)) {
          if (value && value.trim() !== '') {
            propertiesHtml += `<div><strong>${key}:</strong> ${value}</div>`;
          }
        }
        propertiesHtml += '</div>';
      }
      
      html += `
        <div class="cart-drawer-item" data-id="${item.key}">
          <img src="${item.image || 'data:image/svg+xml;utf8,<svg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 100 100%22><rect width=%22100%22 height=%22100%22 fill=%22%23eaf8fc%22/></svg>'}" alt="${item.product_title}" class="cart-drawer-item__img">
          
          <div class="cart-drawer-item__info">
            <div>
              <h4 class="cart-drawer-item__title">${item.product_title}</h4>
              ${variantTitleHtml}
              ${propertiesHtml}
            </div>
            
            <div class="cart-drawer-item__qty">
              <button type="button" class="cart-drawer-item__qty-btn minus-btn" data-key="${item.key}" data-qty="${item.quantity - 1}">-</button>
              <input type="text" class="cart-drawer-item__qty-input" value="${item.quantity}" readonly>
              <button type="button" class="cart-drawer-item__qty-btn plus-btn" data-key="${item.key}" data-qty="${item.quantity + 1}">+</button>
            </div>
          </div>
          
          <div class="cart-drawer-item__price">
            <span>${priceFormatted}</span>
            <button type="button" class="cart-drawer-item__remove" data-key="${item.key}">Remove</button>
          </div>
        </div>
      `;
    });
    itemsContainer.innerHTML = html;

    // Bind quantity and remove click events
    bindItemEvents();
  }

  // Bind clicks on AJAX controls
  function bindItemEvents() {
    itemsContainer.querySelectorAll('.cart-drawer-item__qty-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const key = btn.dataset.key;
        const qty = parseInt(btn.dataset.qty);
        if (qty >= 0) {
          updateQuantity(key, qty);
        }
      });
    });

    itemsContainer.querySelectorAll('.cart-drawer-item__remove').forEach(btn => {
      btn.addEventListener('click', () => {
        const key = btn.dataset.key;
        updateQuantity(key, 0);
      });
    });
  }

  // Update cart item quantity
  function updateQuantity(key, quantity) {
    const data = {
      id: key,
      quantity: quantity
    };

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(res => res.json())
    .then(cart => {
      updateBadgeAndFooter(cart);
      renderCartItems(cart);
    })
    .catch(err => console.error('Error changing cart quantity:', err));
  }

  // Update totals, badge, and footer UI states
  function updateBadgeAndFooter(cart) {
    if (badgeCount) badgeCount.textContent = cart.item_count;
    const bottomCartBadge = document.getElementById('BottomNavCartBadgeCount');
    if (bottomCartBadge) bottomCartBadge.textContent = cart.item_count;
    const headerBadgeCount = document.getElementById('CartDrawerBadgeCount');
    if (headerBadgeCount) headerBadgeCount.textContent = cart.item_count;
    if (subtotalLabel) {
      subtotalLabel.textContent = formatMoney(cart.total_price, Shopify.money_format || '£{{amount}}');
    }
  }

  // Helper money formatter
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || '£{{amount}}';

    function floatToString(numeric, decimals) {
      return numeric.toFixed(decimals).toString();
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = floatToString(cents / 100.0, 2);
        break;
      case 'amount_no_decimals':
        value = floatToString(cents / 100.0, 0);
        break;
      case 'amount_with_comma_separator':
        value = floatToString(cents / 100.0, 2).replace('.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = floatToString(cents / 100.0, 0).replace('.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }
}

/**
 * Mobile Menu Drawer Interaction
 */
function initMobileMenu() {
  const trigger = document.getElementById('MobileMenuTrigger');
  const closeBtn = document.getElementById('MobileMenuCloseBtn');
  const overlay = document.getElementById('MobileMenuDrawerOverlay');
  const drawer = document.getElementById('MobileMenuDrawer');
  
  if (!trigger || !drawer) return;

  const openDrawer = () => {
    drawer.classList.add('active');
    if (overlay) overlay.classList.add('active');
    trigger.classList.add('active');
    trigger.setAttribute('aria-expanded', 'true');
  };

  const closeDrawer = () => {
    drawer.classList.remove('active');
    if (overlay) overlay.classList.remove('active');
    trigger.classList.remove('active');
    trigger.setAttribute('aria-expanded', 'false');
  };

  trigger.addEventListener('click', () => {
    if (drawer.classList.contains('active')) {
      closeDrawer();
    } else {
      openDrawer();
    }
  });

  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  // Close menu if clicking outside
  document.addEventListener('click', (e) => {
    if (!drawer.contains(e.target) && !trigger.contains(e.target) && drawer.classList.contains('active')) {
      closeDrawer();
    }
  });
}

/**
 * Mobile Search Overlay Interactions & Bottom Nav Hooks
 */
function initMobileSearch() {
  const searchTab = document.getElementById('BottomNavSearch');
  const overlay = document.getElementById('MobileSearchOverlay');
  const closeBtn = document.getElementById('MobileSearchCloseBtn');
  const searchInput = document.getElementById('MobileSearchInput');
  const bottomCartTrigger = document.getElementById('BottomNavCart');
  
  // Hook search overlay trigger
  if (searchTab && overlay) {
    searchTab.addEventListener('click', (e) => {
      e.preventDefault();
      overlay.classList.add('active');
      if (searchInput) {
        setTimeout(() => searchInput.focus(), 100);
      }
    });
  }
  
  if (closeBtn && overlay) {
    closeBtn.addEventListener('click', () => {
      overlay.classList.remove('active');
    });
  }
  
  if (overlay) {
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) {
        overlay.classList.remove('active');
      }
    });
  }

  // Hook cart drawer trigger to bottom navigation Cart button
  if (bottomCartTrigger) {
    bottomCartTrigger.addEventListener('click', (e) => {
      e.preventDefault();
      const drawerTrigger = document.getElementById('CartDrawerTrigger');
      if (drawerTrigger) {
        drawerTrigger.click();
      }
    });
  }
}

/**
 * Predictive Search for Mobile Search Overlay
 */
function initMobilePredictiveSearch() {
  const searchInput = document.getElementById('MobileSearchInput');
  const resultsContainer = document.getElementById('MobileSearchResults');
  const loadingIndicator = document.getElementById('MobileSearchLoading');
  
  if (!searchInput || !resultsContainer) return;
  
  let debounceTimer;
  searchInput.addEventListener('input', () => {
    clearTimeout(debounceTimer);
    const query = searchInput.value.trim();
    
    if (query.length < 2) {
      resultsContainer.innerHTML = '';
      if (loadingIndicator) loadingIndicator.style.display = 'none';
      return;
    }
    
    if (loadingIndicator) loadingIndicator.style.display = 'block';
    resultsContainer.innerHTML = '';
    
    debounceTimer = setTimeout(() => {
      fetch(`${window.routes.search_url}/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5`)
        .then(response => response.json())
        .then(data => {
          if (loadingIndicator) loadingIndicator.style.display = 'none';
          
          const products = data.resources.results.products;
          if (products && products.length > 0) {
            let html = '';
            products.forEach(product => {
              const priceFormatted = product.price ? product.price : '';
              html += `
                <a href="${product.url}" class="predictive-search__item">
                  ${product.image ? `<img src="${product.image}" alt="${product.title}" class="predictive-search__item-img">` : ''}
                  <div class="predictive-search__item-info">
                    <h4 class="predictive-search__item-title">${product.title}</h4>
                    <span class="predictive-search__item-price">${priceFormatted}</span>
                  </div>
                </a>
              `;
            });
            resultsContainer.innerHTML = html;
          } else {
            resultsContainer.innerHTML = `<p style="padding: 15px; font-size: 14px; color: var(--mid); text-align: center;">No results found for "${query}"</p>`;
          }
        })
        .catch(err => {
          console.error(err);
          if (loadingIndicator) loadingIndicator.style.display = 'none';
          resultsContainer.innerHTML = '<p style="padding: 15px; font-size: 14px; color: var(--pink); text-align: center;">Error loading search results</p>';
        });
    }, 300);
  });
}

/**
 * Active state management for Bottom Navigation
 */
function initBottomNavActiveState() {
  const path = window.location.pathname;
  
  const homeTab = document.getElementById('BottomNavHome');
  const collectionsTab = document.getElementById('BottomNavCollections');
  const profileTab = document.getElementById('BottomNavProfile');
  const searchTab = document.getElementById('BottomNavSearch');
  const cartTab = document.getElementById('BottomNavCart');
  
  const tabs = [homeTab, collectionsTab, profileTab, searchTab, cartTab];
  
  // Clear previous active states
  tabs.forEach(tab => {
    if (tab) tab.classList.remove('active');
  });
  
  if (path === '/') {
    if (homeTab) homeTab.classList.add('active');
  } else if (path.startsWith('/collections') || path.startsWith('/products')) {
    if (collectionsTab) collectionsTab.classList.add('active');
  } else if (path.startsWith('/account') || path.startsWith('/challenge')) {
    if (profileTab) profileTab.classList.add('active');
  } else if (path.startsWith('/search')) {
    if (searchTab) searchTab.classList.add('active');
  } else if (path.startsWith('/cart')) {
    if (cartTab) cartTab.classList.add('active');
  }
}

/**
 * Storefront Password Page Drawer Toggle
 */
function initPasswordModal() {
  const trigger = document.getElementById('PasswordDrawerTrigger');
  const drawer = document.getElementById('PasswordDrawer');
  const closeBtn = document.getElementById('PasswordDrawerClose');
  const overlay = document.getElementById('PasswordDrawerOverlay');
  const passwordInput = document.getElementById('StorefrontPassword');

  if (!trigger || !drawer) return;

  const openDrawer = () => {
    drawer.classList.add('active');
    drawer.setAttribute('aria-hidden', 'false');
    if (passwordInput) {
      setTimeout(() => passwordInput.focus(), 100);
    }
  };

  const closeDrawer = () => {
    drawer.classList.remove('active');
    drawer.setAttribute('aria-hidden', 'true');
  };

  trigger.addEventListener('click', (e) => {
    e.preventDefault();
    openDrawer();
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', closeDrawer);
  }

  if (overlay) {
    overlay.addEventListener('click', closeDrawer);
  }

  // Escape key close
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('active')) {
      closeDrawer();
    }
  });
}

// Resync watcher trigger
